exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#virtualRecipientsRegisterModal .v--modal-box.v--modal{min-height:410px!important;min-width:460px!important}#virtualRecipientsRegisterModal .modal__content{overflow-y:hidden!important}#virtualRecipientsRegisterModal .modal__footer{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01c5bd95","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/modelWat/modals/VirtualRecipientsRegister.vue
// module id = 1836
// module chunks = 0